import React from 'react';
import { useGlobalActiveGeography, onSetModuleId, onSetDBModuleId, useGlobalModuleId, onSetActiveModuleId, onSetActiveDBModuleId, onSetActiveRGModuleId, onSetActiveSTModuleId, onSetActiveIndicator, onSetSearchLatLng, useGlobalActivePage, useGlobalSelectedId } from '../../data/StatusStore';

export interface ImageChartProps {
  options: any;
  data: any;
  width: number;
  height: number;
  colorClass: string;
}

const Image: React.FC<ImageChartProps> = ({ options, width, height }) => {
  // Get the file name for the image from the options.
  const fileName = options.variables[0].sort["Stories Asset"];
  const moduleId = useGlobalModuleId();
  const activePage = useGlobalActivePage();
  const activeGeography = useGlobalActiveGeography();
  const selectedId = useGlobalSelectedId();
  // Dynamically import the image.
  // Adjust the relative path as needed. This assumes the image exists at:
  // src/assets/pngs/StoriesAsset/<fileName>
  let imageSrc = null;
  if (selectedId) {
    /*selectedId = activeGeography === 'Tract' 
        ? selectedId 
          ? allData[activeGeography].dataJSON[selectedId].GEO_ID_NTA 
            ? allData[activeGeography].dataJSON[selectedId].GEO_ID_NTA 
            : ""
          : ""
        : selectedId
          ? selectedId
          : "";  //allData[selectedId] ? allData[selectedId].id : selectedId;*/
    let prefix = "";
    let suffix = selectedId;
    console.log('B033125 selectedId', selectedId);
    let geoDir = activeGeography === 'Tract' ? 'NTA' : activeGeography;
    let dynamicImage = "";
    if (activeGeography === 'NTA' || activeGeography === 'Tract') {
      prefix = selectedId ? selectedId.slice(0, 2).toLowerCase() : '';
      suffix = selectedId ? selectedId.slice(-4) : '';
    }
    if (activeGeography === 'CD') {
      suffix = `cd${selectedId}`;
    }
    if (activeGeography === 'NTA' || activeGeography === 'Tract') {
      dynamicImage = `${geoDir}/${prefix}/${prefix}${suffix}`;
    } else {
      dynamicImage = `${geoDir}/${suffix}`;
    }
    let _fileName = fileName.replace("{}",dynamicImage);
    //const imageSrc = require(`../../assets/pngs/StoriesAsset/${fileName}`);
    imageSrc = require(`../../${_fileName}`);
  }
  return (
    imageSrc 
    ? <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start', // Align to the top
          overflow: 'hidden',
        }}
      >
        <img
          src={imageSrc}
          alt="Story Asset"
          style={{
            width: 'auto',
            height: 'auto',
            maxWidth: '100%',
            maxHeight: '550px',
            objectFit: 'contain',
          }}
        />
      </div>
    : <></>
  );
};

export default Image;
